module.exports = __webpack_public_path__ + "3ea7eea66304ac5e02a95265505300fd.ttf";